import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@the-platform-group/component-library'
import Modal from 'components/Modal'

/**
 * Modal component for confirming deletion of upload requests
 * @param {object} props - component props
 * @param {boolean} props.open - whether the modal is open
 * @param {function} props.onClose - function to close the modal
 * @param {function} props.onConfirm - function to confirm deletion
 * @param {string} props.requestName - name of the request to delete
 * @param {boolean} props.isLoading - whether the deletion is in progress
 * @returns {React.ReactElement} The rendered DeleteRequestModal component
 */
const DeleteRequestModal = ({ open, onClose, onConfirm, requestName, isLoading = false }) => {
  return (
    <Modal
      open={open}
      handleClose={onClose}
      handleSave={onConfirm}
      title="Delete customer request"
      saveButtonText="Delete"
      showCloseIcon={true}
      isLoading={isLoading}
    >
      <Typography variant="body1">
        Are you sure you want to delete "
        {
          <Typography component="span" sx={{ fontWeight: 'fontWeightMedium' }}>
            {requestName}
          </Typography>
        }
        " request? Once deleted, it cannot be recovered or accessed again and it will also be
        removed from customer's account.
      </Typography>
    </Modal>
  )
}

DeleteRequestModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  requestName: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
}

export default DeleteRequestModal
